import { useGoogleOneTapLogin } from '@react-oauth/google';
import { useMutation } from '@tanstack/react-query';
import { useRouter } from 'next/router';
import toast from 'react-hot-toast';

import queryClient from '@/config/queryClient';
import { queries } from '@/queries';
import { EnumAccountType, postGoogleOneTap } from '@/services/auth/auth';

import { useProfile } from './useProfile';

type UseGoogleOneTapLoginArguments = Parameters<typeof useGoogleOneTapLogin>[0];

export const useGoogleOneTap = (
  accountType: EnumAccountType,
  args?: UseGoogleOneTapLoginArguments
) => {
  const router = useRouter();
  const { data: profileData, isFetching } = useProfile();
  const { mutate } = useMutation({
    mutationFn: postGoogleOneTap,
    mutationKey: ['googleOneTap'],
    onSuccess: (resData) => {
      queryClient.resetQueries({ queryKey: queries.profile.me.queryKey });
      if (resData.user.accountType === EnumAccountType.CUSTOMER)
        router.push('/dashboard');
    },
  });

  return useGoogleOneTapLogin({
    ...args,
    disabled: !!profileData || isFetching,
    onSuccess: async (data) => {
      if (!data.credential) {
        return toast.error('Google One Tap Login Failed');
      }
      mutate({ credential: data.credential, accountType });
    },
  });
};
